import { combineReducers, configureStore } from '@reduxjs/toolkit'
import agenticReducer, { agenticDefaultState } from '~/agentic-ux/slice'
import appReducer from './appSlice'
import campaignLimitReducer, { campaignLimitDefaultState } from './campaignLimitSlice'
import chatReducer from './chatSlice'
import codeReducer from './codeSlice'
import connectionReducer, { connectionDefaultState } from './connectionSlice'
import containerReducer, { containerDefaultState } from './containerSlice'
import conversationReducer from './conversationSlice'
import dirHandleReducer, { dirHandleDefaultState } from './dirHandleSlice'
import editorReducer from './editorSlice'
import errorsReducer from './errorsSlice'
import fileExplorerReducer from './fileExplorerSlice'
import flowReducer from './flowSlice'
import galleryScreenReducer from './galleryScreenSlice'
import inlineChatReducer from './inlineChatSlice'
import modalsReducer from './modalSlice'
import pageReducer from './pageSlice'
import settingReducer, { settingsDefaultState } from './settingsSlice'
import taskFormReducer from './taskFormSlice'
import tutorialReducer, { tutorialDefaultState } from './tutorialSlice'
import { loadStateFromLocalStorage, localStorageMiddleware } from './utils'

export const rootReducer = combineReducers({
  app: appReducer,
  conversation: conversationReducer,
  chat: chatReducer,
  code: codeReducer,
  errors: errorsReducer,
  container: containerReducer,
  settings: settingReducer,
  flow: flowReducer,
  fileExplorer: fileExplorerReducer,
  editor: editorReducer,
  inlineChat: inlineChatReducer,
  modals: modalsReducer,
  connection: connectionReducer,
  tutorial: tutorialReducer,
  page: pageReducer,
  taskForm: taskFormReducer,
  galleryScreen: galleryScreenReducer,
  campaignLimit: campaignLimitReducer,
  dirHandle: dirHandleReducer,
  agentic: agenticReducer
})

const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    container: loadStateFromLocalStorage('container', containerDefaultState),
    settings: loadStateFromLocalStorage('settings', settingsDefaultState),
    connection: loadStateFromLocalStorage('connection', connectionDefaultState),
    tutorial: loadStateFromLocalStorage('tutorial', tutorialDefaultState),
    campaignLimit: loadStateFromLocalStorage('campaignLimit', campaignLimitDefaultState),
    dirHandle: loadStateFromLocalStorage('dirHandle', dirHandleDefaultState),
    agentic: loadStateFromLocalStorage('agentic', agenticDefaultState)
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      localStorageMiddleware('container'),
      localStorageMiddleware('settings'),
      localStorageMiddleware('connection'),
      localStorageMiddleware('tutorial'),
      localStorageMiddleware('campaignLimit'),
      localStorageMiddleware('dirHandle'),
      localStorageMiddleware('agentic')
    ])
})

export type RootState = ReturnType<typeof store.getState>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch

export default store
